import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { type Observable } from 'rxjs';
import { type ITimeZonesDto } from '@pecan/api';
import { AppSettings } from '@pecan/config';

@Injectable({
    providedIn: 'root',
})
export class TimeZoneService {
    private _http: HttpClient = inject(HttpClient);

    public getTimeZones(): Observable<ITimeZonesDto> {
        return this._http.get<ITimeZonesDto>(`${AppSettings.apiHost}/serialnumber/v2/info/timezones`);
    }
}
